import { get, post } from './client';

/**
 * 
 * @returns 
 */
export function getDashboard() {
    return get('dashboard')
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function coursesDeliveredByDay(data) {
    return post('dashboard/delivered', data)
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function coursesPlannedByDay(data) {
    return post('dashboard/planned', data)
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function coursesFailedByDay(data) {
    return post('dashboard/failed', data)
}

/**
 * 
 * @returns 
 */
export function coursesStatusByDay() {
    return get('dashboard/status')
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function coursesMerchantPrice(data) {
    return post('dashboard/merchantprice', data)
}
